import { getAllCameraStorageKeys } from 'src/services/cam-cloud/recordings';
import { camera_storage_keys } from 'src/components/Camera/stores/camera_storage_keys';

/**
 * Loads every camera's encrypted `master_key` backup **history** and caches the
 * full array (newest first) per device in the {@link camera_storage_keys} store,
 * so key rotation is preserved and older recordings stay decryptable.
 */
export const loadCameraStorageKeys = async (): Promise<void> => {
	const response = await getAllCameraStorageKeys().catch((err) => {
		console.error('[Camera Cloud] Error fetching camera storage keys', err);
		return null;
	});

	if (!response) return;

	for (const [mac, entries] of Object.entries(response)) {
		const history = Array.isArray(entries)
			? entries
					.filter((entry) => entry?.blob && entry?.hmac)
					.map((entry) => ({ blob: entry.blob, hmac: entry.hmac, createdAt: entry.createdAt }))
			: [];
		if (history.length) {
			camera_storage_keys.setAll(mac, history);
		}
	}
};

/**
 * Runs the camera-side loading needed on account bootstrap.
 */
export const cameraServicesInitialLoad = async (): Promise<void> => {
	await loadCameraStorageKeys();
};
